module.exports = __webpack_public_path__ + "img/success-g13c12807a_1920.3b4e7b04.jpg";